import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/assets/css/index.css";
import App from "@/App";

const rootElement = document.getElementById("react-app");

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
